import React from "react";

type Props = {
  onOpen: () => void;
};

const SessionBurgerMenu: React.FC<Props> = ({ onOpen }) => {
  return (
    <button
      className="session-burger-button"
      onClick={onOpen}
      aria-label="Open menu"
    >
      <span />
      <span />
      <span />
    </button>
  );
};

export default SessionBurgerMenu;